<template>
    <div class="container-fluid justify-content-center">

        <general-notifications></general-notifications>

        <div class="d-flex justify-content-between mb-2">
            <b-form-select v-model="status" @change="loadNewStatus" style="width: auto;">
                <template>
                    <b-form-select-option v-for="statusOption in filters" :value="statusOption" :key="statusOption">{{statusOption}}</b-form-select-option>
                </template>
            </b-form-select>
        </div>


        <div v-if="(!threads || threads.length === 0)" class="text-center mt-5">
            <p>InboxGPT is off to a wild party, but don't worry, messages will join the fun soon!  🎉</p>
            <img src="/welcome.svg" style="max-width: 400px;">
        </div>
        <div v-else>
            <div class="d-lg-flex justify-content-between" style="gap: 20px;">
                <div style="width: 40%;">
                    <b-list-group>
                        <template v-for="thread in threads">
                            <b-list-group-item
                                class="hover-card" @click="fetchMessages(thread.id)"
                                :class="[
                                  { active_thread: threadId === thread.id },
                                  thread.is_read ? 'thread_card_read' : 'thread_card_unread'
                                ]"
                            >
                                <div class="d-flex justify-content-between">
                                    <p class="my-0 font-weight-bold"><b-icon icon="circle-fill" class="text-primary" v-if="!thread.is_read"></b-icon> {{thread.customer_name}}</p>
                                    <p class="text-muted small">{{thread.last_received_message_date_formatted}}</p>
                                </div>
                                <div class="d-flex justify-content-between my-1">
                                    <p class="flex-grow-1" :class="{'font-weight-bold': !thread.is_read}">{{thread.subject}}</p>
                                    <p><span class="badge badge-light" :style="'background-color: '+getColorByStatus(thread.status)+';'">{{thread.status}}</span></p>
                                </div>
                                <p class="my-0 text-muted" :class="{'font-weight-bold': !thread.is_read}">{{thread.snippet}}</p>
                            </b-list-group-item>
                        </template>
                    </b-list-group>
                </div>
                <div :style="{ width: displayCustomerPanel ? '50%' : '75%' }">
                    <div v-if="loading" class="text-center">
                        <b-spinner></b-spinner>
                    </div>
                    <div v-else>
                        <div class="messages-container" ref="messageContainer">
                            <div class="d-flex justify-content-between mb-5">
                                <div>
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1 d-flex align-items-center">
                                            <b-button-group>
                                                <b-button v-if="!changedStatus" @click="changeThreadStatus(threadId, 'closed'); changedStatus = false" variant="outline" title="Change status to closed." v-b-tooltip>Close</b-button>
                                                <b-button v-if="!changedStatus" @click="changedStatus = true" variant="outline" title="Change status of this thread." v-b-tooltip>Status</b-button>
                                            </b-button-group>

                                            <template v-if="changedStatus">
                                                <b-form-select v-model="thread.status">
                                                    <option v-for="status in statuses" :value="status.status" :selected="status.status === thread.status">{{ status.status }}</option>
                                                </b-form-select>
                                                <b-tooltip :target="'question-mark'" placement="top" triggers="hover">
                                                    Selected status: {{selectedStatusDescription}}
                                                </b-tooltip>
                                                <span class="px-2"><b-icon-question-circle-fill variant="grey" id="question-mark"></b-icon-question-circle-fill></span>

                                                <b-button variant="primary" @click="changeThreadStatus(threadId, thread.status); changedStatus = false">Save</b-button>
                                            </template>
                                        </div>

                                        <b-button v-if="!thread.is_read" @click="changeThreadReadStatus('read')" variant="outline" class="mx-2">Mark read</b-button>
                                        <b-button v-if="thread.is_read" @click="changeThreadReadStatus('unread')" variant="outline" class="mx-2">Mark not read</b-button>
                                    </div>
                                </div>

                                <div>
                                    <b-button @click="quickReply()" variant="primary" :disabled="isReply" class="mx-2"><b-icon icon="reply" flip-h></b-icon> Reply</b-button>
<!--                                    <b-button @click="openReply()" variant="primary" :disabled="isReply"><b-icon icon="cloud"></b-icon> AI Reply</b-button>-->
                                </div>
                            </div>


                            <template v-for="message in messages">
                                <message :message="message"></message>
                            </template>

                            <div class="d-flex justify-content-between mb-5">
                                <div>
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1 d-flex align-items-center">
                                            <b-button-group>
                                                <b-button v-if="!changedStatus" @click="changeThreadStatus(threadId, 'closed'); changedStatus = false" variant="outline" title="Change status to closed." v-b-tooltip>Close</b-button>
                                                <b-button v-if="!changedStatus" @click="changedStatus = true" variant="outline" title="Change status of this thread." v-b-tooltip>Status</b-button>
                                            </b-button-group>

                                            <template v-if="changedStatus">
                                                <b-form-select v-model="thread.status">
                                                    <option v-for="status in statuses" :value="status.status" :selected="status.status === thread.status">{{ status.status }}</option>
                                                </b-form-select>
                                                <b-tooltip :target="'question-mark'" placement="top" triggers="hover">
                                                    Selected status: {{selectedStatusDescription}}
                                                </b-tooltip>
                                                <span class="px-2"><b-icon-question-circle-fill variant="grey" id="question-mark"></b-icon-question-circle-fill></span>

                                                <b-button variant="primary" @click="changeThreadStatus(threadId, thread.status); changedStatus = false">Save</b-button>
                                            </template>
                                        </div>

                                        <b-button v-if="!thread.is_read" @click="changeThreadReadStatus('read')" variant="outline" class="mx-2">Mark read</b-button>
                                        <b-button v-if="thread.is_read" @click="changeThreadReadStatus('unread')" variant="outline" class="mx-2">Mark not read</b-button>
                                    </div>
                                </div>

                                <div>
                                    <b-button @click="quickReply()" variant="primary" :disabled="isReply" class="mx-2"><b-icon icon="reply" flip-h></b-icon> Reply</b-button>
<!--                                    <b-button @click="openReply()" variant="primary" :disabled="isReply"><b-icon icon="cloud"></b-icon> AI Reply</b-button>-->
                                </div>
                            </div>
                        </div>

                        <div  v-if="isReply" class="card mt-2" ref="replyContainer">
                            <div class="card-body">
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="card-header m-0 p-0 border-0">Reply</span>
                                    <div class="d-flex align-items-center">
                                        <div class="d-flex justify-content-between align-items-center" style="background-color: #f8fafc; border-radius: 5px; padding: 5px;">
                                            <p class="small m-0 p-0">Tone:</p>
                                            <b-form-group id="ai_styleFormGroup" label-for="ai_styleSelect" class="ml-2 mb-0">
                                                <validation-provider name="Tone" rules="required" v-slot="{ errors }">
                                                    <b-form-select id="ai_styleSelect" v-model="aiTone" size="sm" @change="proposeReply(threadId)">
                                                        <option v-for="tone in ai_tones" :key="tone.key" :value="tone.key">{{ ucFirst(tone.name) }}</option>
                                                    </b-form-select>
                                                    <span class="validation">{{ errors[0] }}</span>
                                                </validation-provider>
                                            </b-form-group>
                                        </div>
                                        <b-button variant="outline" class="ml-2"  v-b-toggle.to-collapse>To / CC</b-button>
                                    </div>
                                </div>


                                <div v-if="loadingProposal" class="text-center">
                                    <b-spinner></b-spinner>
                                    <p>{{ randomLoadingText }}</p>
                                    <b-button variant="outline" class="btn-sm" @click="skipProposal()">Cancel AI</b-button>
                                </div>
                                <template v-else>
                                    <validation-observer ref="observer" v-slot="{ passes }">
                                        <b-form @submit.stop.prevent="passes(sendReply)">
                                            <b-collapse id="to-collapse">
                                                <div class="d-flex justify-content-between">
                                                    <b-form-group label="To:" label-for="replyTo" label-cols-sm="4"
                                                                  label-cols-lg="3"
                                                                  content-cols-sm
                                                                  content-cols-lg="7"
                                                                  class="flex-grow-1">
                                                        <validation-provider name="Email" rules="required|email" v-slot="{ errors }">
                                                            <b-form-input v-model="replyTo" id="replyTo" placeholder="Enter customer email"></b-form-input>
                                                            <span class="validation">{{ errors[0] }}</span>
                                                        </validation-provider>
                                                    </b-form-group>
                                                </div>
                                            </b-collapse>

<!--                                            <div class="d-flex justify-content-between align-items-end mb-2">-->
<!--&lt;!&ndash;                                                <div class="flex-grow-1">&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <b-badge style="cursor: pointer;" @click="proposeWithInput('thanks')">Thanks</b-badge>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <b-badge  style="cursor: pointer;" @click="proposeWithInput('done')">Done</b-badge>&ndash;&gt;-->
<!--&lt;!&ndash;                                                    <b-badge  style="cursor: pointer;" @click="proposeWithInput('working on it')">Working on it</b-badge>&ndash;&gt;-->
<!--&lt;!&ndash;                                                </div>&ndash;&gt;-->
<!--                                                <div>-->
<!--                                                    <div>-->
<!--                                                        <div class="d-flex justify-content-between align-items-center" style="background-color: #f8fafc; border-radius: 5px; padding: 5px;">-->
<!--                                                            <p class="small m-0 p-0">Tone:</p>-->
<!--                                                            <b-form-group id="ai_styleFormGroup" label-for="ai_styleSelect" class="ml-2 mb-0">-->
<!--                                                                <validation-provider name="Tone" rules="required" v-slot="{ errors }">-->
<!--                                                                    <b-form-select id="ai_styleSelect" v-model="aiTone" size="sm">-->
<!--                                                                        <option v-for="tone in ai_tones" :key="tone.key" :value="tone.key">{{ ucFirst(tone.name) }}</option>-->
<!--                                                                    </b-form-select>-->
<!--                                                                    <span class="validation">{{ errors[0] }}</span>-->
<!--                                                                </validation-provider>-->
<!--                                                            </b-form-group>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </div>-->

                                            <b-form-group style="position: relative;">
                                                <b-button style="position: absolute; top: 5px; right: 5px;" @click="proposeWithTextareaInput()" variant="outline">Improve writing</b-button>
                                                <vue-editor v-model="reply" id="messageEditor" :editor-toolbar="customEditorToolbar"></vue-editor>
                                            </b-form-group>

                                            <div class="d-flex justify-content-between">
                                                <b-button variant="outline" @click="isReply = false">Cancel</b-button>
                                                <div>
                                                    <b-button type="submit" variant="outline" :disabled="sending">
                                                        <b-spinner small v-if="sending"></b-spinner>
                                                        Send
                                                    </b-button>
                                                    <b-button type="submit" variant="primary" :disabled="sending" @click="sendAndClose = true">
                                                        <b-spinner small v-if="sending"></b-spinner>
                                                        Send & Close
                                                    </b-button>
                                                </div>
                                            </div>
                                        </b-form>
                                    </validation-observer>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="displayCustomerPanel" style="width: 15%;" class="customer-panel-container">
                    <div v-if="loadingCustomerPanel" class="text-center">
                        <b-spinner></b-spinner>
                    </div>

                    <template  v-else>
                        <p class="font-weight-bold mb-3">{{thread.customer_name}}</p>
                        <table class="table table-striped small">
                            <tbody>
                                <template v-for="(data) in customerPanelData">
                                    <tr v-for="(value, key) in data" :key="key">
                                        <td class="text-break"><b>{{ key }}</b></td>
                                        <td class="text-break">{{ value }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </template>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import NotificationPop
    from '../mixins/NotificationPop.js';
import GeneralNotifications
    from "../components/GeneralNotifications";
import Message
    from "../components/Message";
import {
    VueEditor
} from "vue2-editor";
import InfoNotification
    from "../mixins/InfoNotification";

export default {
    mixins: [NotificationPop, InfoNotification],
    components: {
        Message,
        GeneralNotifications,
        VueEditor
    },
    data() {
        return {
            customEditorToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
            ],
            loadingTexts: [
                "Training our AI to craft the perfect reply...",
                "Harnessing the power of AI for your reply...",
                "Engaging our AI assistants to write a clever response...",
                "Assembling the neural networks to compose your reply...",
                "Loading AI creativity module for responses...",
                "Unlocking the AI's sense of humor for your reply...",
                "Processing AI algorithms to generate a clever reply...",
                "Waiting for the AI to concoct the perfect response...",
                "Using AI magic to craft a reply...",
                "Empowering our AI to send a message...",
                "Utilizing the brilliance of AI for a reply...",
                "Relying on AI's sense of urgency for your reply...",
                "Unleashing the AI's wit for a clever response...",
                "Leveraging AI brainpower to compose a reply...",
                "Syncing with AI for an intelligent message...",
                "Bringing the AI some coffee...",
                "Doing yoga with the AI...",
                "Taking the AI out camping...",
            ],
            randomLoadingText: "",

            statuses: [
                // color: tailwind-100 https://tailwindcss.com/docs/customizing-colors
                {"status": "new", "description": "The ticket has been created, but not yet assigned to any agent.", "color": "#fef9c3"},
                {"status": "assigned", "description": "The ticket has been assigned to an agent who will work on it.", "color": "#fae8ff"},
                {"status": "in progress", "description": "The agent is currently working on the ticket.", "color": "#ede9fe"},
                {"status": "pending customer", "description": "The agent needs more information or action from the customer to proceed.", "color": "#cffafe"},
                {"status": "pending internal", "description": "The ticket requires an internal action before it can be resolved.", "color": "#fee2e2"},
                {"status": "on hold", "description": "The ticket can't be resolved for now due to various reasons.", "color": "#f3f4f6"},
                {"status": "closed", "description": "The issue has been resolved and the ticket is closed.", "color": "#dcfce7"},
                {"status": "reopened", "description": "The ticket was previously closed, but has been reopened.", "color": "#fce7f3"},
            ],

            "ai_tones": [
                {
                    "name": "😊 Appreciative",
                    "description": "Expresses gratitude, thanks, or appreciation towards the recipient.",
                    "key": "appreciative"
                },
                {
                    "name": "👍 Assertive",
                    "description": "Confident, direct, and to the point. Used for expressing strong opinions or making firm requests.",
                    "key": "assertive"
                },
                {
                    "name": "🎯 Authoritative",
                    "description": "Confident, commanding, and assertive. Establishes authority or expertise on a subject.",
                    "key": "authoritative"
                },
                {
                    "name": "🤝 Conciliatory",
                    "description": "Diplomatic, cooperative, and seeks to find common ground or resolve conflicts.",
                    "key": "conciliatory"
                },
                {
                    "name": "❓ Curious",
                    "description": "Inquisitive and exploratory. Asks questions or seeks information to encourage a dialogue.",
                    "key": "curious"
                },
                {
                    "name": "❤️ Empathetic",
                    "description": "Demonstrates understanding, empathy, and sensitivity towards the recipient's situation or concerns.",
                    "key": "empathetic"
                },
                {
                    "name": "💥 Energetic",
                    "description": "Vibrant, lively, and full of enthusiasm. Creates an energetic and dynamic tone.",
                    "key": "energetic"
                },
                {
                    "name": "🌟 Friendly",
                    "description": "Warm, conversational, and casual. Suitable for informal communication or maintaining a friendly tone.",
                    "key": "friendly"
                },
                {
                    "name": "😄 Humorous",
                    "description": "Incorporates humor, wit, or light-heartedness to create an engaging and entertaining email.",
                    "key": "humorous"
                },
                {
                    "name": "ℹ️ Informative",
                    "description": "Focuses on providing clear and concise information. Suitable for instructional or educational emails.",
                    "key": "informative"
                },
                {
                    "name": "🌈 Inspirational",
                    "description": "Motivational and uplifting. Includes encouraging words or positive affirmations to inspire action.",
                    "key": "inspirational"
                },
                {
                    "name": "🔍 Objective",
                    "description": "Neutral, unbiased, and focuses on presenting facts or information without personal opinion.",
                    "key": "objective"
                },
                {
                    "name": "💪 Persuasive",
                    "description": "Convincing and influential. Utilizes compelling language to persuade the reader.",
                    "key": "persuasive"
                },
                {
                    "name": "💼 Professional",
                    "description": "Formal, polite, and suitable for business-related emails or professional communication.",
                    "key": "professional"
                },
                {
                    "name": "🤗 Supportive",
                    "description": "Compassionate, encouraging, and helpful. Provides support, reassurance, or guidance to the recipient.",
                    "key": "supportive"
                },
                {
                    "name": "🤔 Thoughtful",
                    "description": "Considerate, introspective, and carefully reflects on the topic or subject matter.",
                    "key": "thoughtful"
                },
                {
                    "name": "⏰ Urgent",
                    "description": "Conveys a sense of urgency or importance. Used for time-sensitive matters or immediate action.",
                    "key": "urgent"
                }
            ],


            filters: ["all except closed", "new", "assigned", "in progress", "pending customer", "pending internal", "on hold", "closed", "reopened"],

            user: {},
            loading: true,
            password: null,
            confirmPassword: null,
            changedStatus: false,
            threads: {},
            messages: {},
            reply: '',
            isReply: false,
            threadId: null,
            loadingProposal: false,
            skippedProposal: false,
            proposalForThreadId: null,
            status: 'all except closed',
            replyTo: null,
            thread: {},
            sending: false,
            displayCustomerPanel: false,
            customerPanelUrl: null,
            loadingCustomerPanel: true,
            customerPanelData: {},
            sendAndClose: false,
            aiTone: null
        };
    },
    computed: {
        selectedStatusDescription() {
            const selectedStatus = this.statuses.find(status => status.status === this.thread.status);
            return selectedStatus ? selectedStatus.description : '';
        }
    },
    watch: {
        customerPanelUrl(newValue, oldValue) {
            // Execute your action or call a method here
            this.loadCustomerPanel(newValue, oldValue);
        }
    },
    mounted() {
        // Start the interval to change the loading text every 2 seconds
        this.randomLoadingText = this.getRandomLoadingText();
        setInterval(() => {
            this.randomLoadingText = this.getRandomLoadingText();
        }, (1000 * 2));

        // Refresh threads
        setInterval(() => {
            this.fetchThreads();
        }, (1000 * 30));
    },
    created() {
        this.loadInbox();
    },
    methods: {
        loadCustomerPanel(newValue, oldValue) {
            if(newValue === oldValue) return true;

            if(newValue === null) {
                this.displayCustomerPanel = false
                return true;
            }

            this.loadingCustomerPanel = true
            this.displayCustomerPanel = true

            this.$http
                .get(this.customerPanelUrl)
                .then(response => {
                    this.customerPanelData = response.data.data;
                    this.loadingCustomerPanel = false
                })
                .catch(error => {
                    console.error(error);
                    this.customerPanelData = {'Message': 'Cannot load customer panel data.'}
                });
        },
        getColorByStatus(status) {
            const statusObj = this.statuses.find(item => item.status === status);
            if (statusObj) {
                return statusObj.color;
            }
            return null; // or a default color value if needed
        },
        async loadInbox() {
            try {
                await this.fetchThreads();
                // Next step goes here

                // Check if there are threads available
                if (this.threads.length > 0) {
                    // Fetch messages for the first thread
                    this.fetchMessages(this.threads[0].id);
                }
            } catch (error) {
                console.error(error);
                // Handle error here
            }
        },
        executeDelayedIsRead(threadId) {
            if (threadId !== threadId) return false;

            this.changeThreadReadStatus('read');
        },
        async loadNewStatus() {
            await this.fetchThreads();
            // Check if there are threads available
            if (this.threads.length > 0) {
                // Fetch messages for the first thread
                this.fetchMessages(this.threads[0].id);
            }
        },
        fetchThreads() {
            return new Promise((resolve, reject) => {
                // Fetch threads data from API
                this.$http
                    .get('threads/', { params: {status: this.status}})
                    .then(response => {
                        this.threads = response.data.data;
                        resolve()
                    })
                    .catch(error => {
                        console.error(error);
                        reject()
                    });
            });
        },
        fetchMessages(threadId) {
            this.loading = true
            this.threadId = threadId

            // Fetch thread info
            this.$http
                .get(`threads/${threadId}`)
                .then(response => {
                    this.thread = response.data.data;
                    this.replyTo = this.thread.customer_identifier
                    this.customerPanelUrl = this.thread.customer_panel_url
                    this.aiTone = this.thread.tone;

                    // setTimeout(() => {
                    //     this.executeDelayedIsRead(threadId);
                    // }, 10000);

                    this.proposeReply(threadId, 'automated');
                })
                .catch(error => {
                    console.error(error);
                });

            // Fetch messages data for the specified thread ID
            this.$http
                .get(`threads/${threadId}/messages`)
                .then(response => {
                    this.reply = ''
                    this.isReply = false
                    this.messages = response.data.data;

                    this.loading = false

                    // Scroll to the last displayed message
                    this.scrollToLastMessage()
                })
                .catch(error => {
                    console.error(error);
                });
        },
        sendReply() {
            let threadId = this.threadId

            this.sending = true

            // Prepare the payload
            const payload = {
                message: this.reply,
                to_identifier: this.replyTo
            };

            // Make a POST request to initiate the reply
            this.$http.post(`/threads/${threadId}/reply`, payload)
                .then(response => {
                    // Handle the success response
                    console.log('Reply sent successfully');

                    this.isReply = false
                    this.sending = false

                    this.messages.push(response.data.data);

                    if(this.sendAndClose) {
                        this.changeThreadStatus(threadId, 'closed');
                        this.sendAndClose = false;
                        this.popNotification('Reply sent & closed thread', 'success')
                    } else {
                        this.popNotification('Reply sent', 'success')
                    }

                    if(this.$auth.user().count_sent_replies === 0) {
                        this.infoNotification('First message sent 🙌', 'InboxGPT is thrilled to learn from each email you send, gearing up to offer even more accurate suggestions. With every exchange, InboxGPT\'s expertise grows, ensuring a faster email experience for you. ')
                        this.$auth.user().count_sent_replies = 1
                    }
                })
                .catch(error => {
                    // Handle the error response
                    console.error('Error sending reply:', error.response.data.error);
                    // Perform any necessary actions after failed reply
                });
        },

        changeThreadStatus(threadId, newStatus) {
            const data = { status: newStatus };

            this.$http
                .post(`threads/${threadId}/status`, data)
                .then(response => {
                    this.popNotification('Status updated', 'success')

                    this.openNext();

                    // Check if this item should stay in view
                    if(this.status !== 'all except closed' || newStatus === 'closed') {
                        // Remove the thread from view
                        this.threads = this.threads.filter(thread => thread.id !== threadId);
                    } else {
                        // Need to update the status on the left
                        this.threads = this.threads.map(thread => {
                            if (thread.id === threadId) {
                                // Update the status field of the matching thread
                                thread.status = newStatus;
                            }
                            return thread;
                        });
                    }
                })
                .catch(error => {
                    console.error('Error sending thread status:', error);
                    console.error('Error changing thread status:', error);
                });
        },

        openNext() {
            let threadId = this.threadId

            // Find the index of the current thread
            const currentIndex = this.threads.findIndex(thread => thread.id === threadId);

            // Open the next thread if available
            if (currentIndex !== -1 && currentIndex + 1 < this.threads.length) {
                const nextThreadId = this.threads[currentIndex + 1].id;
                this.fetchMessages(nextThreadId); // Assuming there is an "openThread" function to display the thread
            }
        },

        scrollToLastMessage() {
            // Scroll to the last displayed message
            this.$nextTick(() => {
                const messageContainer = this.$refs.messageContainer;
                if (messageContainer) {
                    messageContainer.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
            });
        },


        getRandomLoadingText() {
            const randomIndex = Math.floor(Math.random() * this.loadingTexts.length);
            return this.loadingTexts[randomIndex];
        },
        openReply() {
            if(!this.isReply) {
                this.isReply = true
                this.skippedProposal = false
                // this.proposeReply(this.threadId, 'userClick')
            }

            this.scrollToReply()
        },
        scrollToReply() {
            this.$nextTick(() => {
                this.$refs.replyContainer.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end'
                });
            });
        },
        skipProposal() {
            this.loadingProposal = false;
            this.skippedProposal = true
        },
        proposeWithTextareaInput() {
            let input = this.reply;

            // remove signature
            if(this.thread.signature) {
                input = input.replace(this.thread.signature, '');
            }

            // Continue
            this.proposeWithInput(input)
        },

        proposeWithInput(input) {
            this.skippedProposal = false
            this.proposeReply(this.threadId, 'userClick', input)
        },
        proposeReply(threadId, eventType, input) {
            // Don't execute, new way
            // if(eventType === 'automated') return false;

            // alert('loading proposl' + threadId);

            this.proposalReady = false;
            this.loadingProposal = true;
            this.proposalForThreadId = threadId

            const data = { input: input, tone: this.aiTone };

            // Make a POST request to the proposeReply endpoint
            this.$http.post(`threads/${threadId}/propose-reply`, data)
                .then(response => {
                    // Access the proposal from the response
                    // Don't show if the user already switched
                    if(this.proposalForThreadId === threadId) {
                        this.reply =response.data.proposal;
                        this.loadingProposal = false;
                        this.proposalReady = true;
                    } else {
                        this.loadingProposal = false;
                    }
                })
                .catch(error => {
                    console.error(error);
                    // Handle any errors that occurred during the request
                });
        },

        retryProposal() {
            this.proposalReady = false;
            this.proposeReply(this.threadId,'userClick')
        },

        quickReply() {
            // this.skippedProposal = true;
            // this.proposalReady = false;
            this.isReply = true
            // if(this.thread.signature) {
            //     this.reply = "\n\n" + this.thread.signature
            // }
            this.scrollToReply()
        },

        changeThreadReadStatus(newStatus) {
            let threadId = this.threadId

            this.$http
                .put(`threads/${threadId}/mark-as-${newStatus}`)
                .then(response => {
                    // this.popNotification('Done', 'success');

                    // Update the status on the left
                    this.threads = this.threads.map(thread => {
                        if (thread.id === threadId) {
                            if(newStatus === 'read') {
                                thread.is_read = 1
                            } else {
                                thread.is_read = 0
                            }
                        }
                        return thread;
                    });
                    // adjust current open thread
                    if(newStatus === 'read') {
                        this.thread.is_read = 1
                    } else {
                        this.thread.is_read = 0
                    }
                })
                .catch(error => {
                    console.error('Error changing thread read status:', error);
                });
        },
        ucFirst(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
    },
};
</script>

